export default __webpack_public_path__ + "static/210526_妲絲刷關活動熱更完成_jp-3c59968697cb6b04dcd2b4439efcc0fb.webp";